import { Helmet } from 'react-helmet-async'
import { useLanguage } from '../context/LanguageContext'

const SEO = ({ title, description, keywords, ogImage }) => {
  const { language } = useLanguage()
  
  const siteName = 'Contenta Marketing'
  const siteUrl = 'https://contenta.marketing'
  const defaultImage = `${siteUrl}/logo.png`
  
  const fullTitle = title ? `${title} | ${siteName}` : siteName
  const image = ogImage || defaultImage

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="title" content={fullTitle} />
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      <html lang={language} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={siteUrl} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:site_name" content={siteName} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={siteUrl} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {/* Additional SEO */}
      <meta name="robots" content="index, follow" />
      <meta name="language" content={language === 'sq' ? 'Albanian' : 'English'} />
      <meta name="author" content={siteName} />
      <link rel="canonical" href={siteUrl} />
    </Helmet>
  )
}

export default SEO
